"use strict";
var warp_router_1 = require("warp-router");
var Configuration_1 = require("../../src/Configuration");
function createDemo() {
    var routes = new Map();
    routes.set("", function () {
        return "This is the home page";
    });
    routes.set("#page1", function () {
        return "This is page 1";
    });
    routes.set("#page2", function () {
        return "This is page 2";
    });
    var configuration = new Configuration_1.Configuration();
    configuration.defaultRoute = "";
    var component = new warp_router_1.default('.container', routes, configuration);
}
createDemo();



//////////////////
// WEBPACK FOOTER
// ./index.ts
// module id = 2
// module chunks = 0